<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Select an Add-on</h5>
        <div class="component-options">
          <div
            v-if="hasEmergencyDrivers"
            :class="{ selected: selected === 'emergency-driver' }"
            class="image-box"
            @click="selected = 'emergency-driver'"
          >
            <img
              :src="isBodine ? driversBodine : driversTrustSight"
              alt="driver-image"
            />
            <span>Emergency drivers</span>
          </div>
        </div>
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
          <input
            type="submit"
            class="btn btn-secondary"
            value="Select"
            :disabled="selectDisabled"
            @click="clickedSelect"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as driversTrustSight from "@/assets/img/drivers-trustsight.jpg";
import * as driversBodine from "@/assets/img/bodine.jpg";
import * as node from "@/assets/img/sensor-node_300x300px.jpg";

export default {
  name: "SaveSolutionModal",
  data() {
    return {
      show: true,
      selected: null,
      driversTrustSight: driversTrustSight,
      driversBodine: driversBodine,
      node: node,
    };
  },
  methods: {
    clickedSelect() {
      if (this.selected === "emergency-driver") {
        this.onOpenEmergencyDrivers();
      }
    },

    onOpenEmergencyDrivers() {
      this.$emit("onOpenEmergencyDrivers");
      this.show = false;
    },

    clickedCancel() {
      this.show = false;
    },
  },
  computed: {
    ...mapState("brain", ["region"]),

    selectDisabled() {
      return this.selected === null;
    },

    isBodine() {
      return this.region === "na";
    },

    hasEmergencyDrivers() {
      return this.region === "na" || this.region === "emea";
    },
  },
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;

  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }

  .component-options {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 45px;

    :first-child {
      margin-right: 20px;
    }

    .image-box {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      width: 50%;

      &.selected {
        img {
          border: 1px solid $blue-500;
        }

        &:hover {
          img {
            border: 1px solid $blue-500;
          }
        }
      }

      &:hover {
        img {
          border: 1px solid #d4d4d4;
        }
      }

      &.single {
        width: 50%;
      }

      img {
        width: 100%;
        border: 1px solid #e9e9e9;
        padding: 20px;
      }

      span {
        margin-top: 5px;
        text-align: center;
      }
    }
  }

  .component-button {
    margin-top: auto;
    display: flex;

    input {
      width: 100%;
      margin: 0 20px 0 0;

      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
